import { Chart, ChartFull } from 'interfaces/chart';
import { QueryParams, Strapi } from './strapi';
import { ApiCollection, ApiDocument } from 'interfaces/api';
import { ChartService } from '../abstract/chart';
import { ContentType } from 'services/abstract';

export class RemoteChartService extends ChartService {
  constructor(private strapiService: Strapi) {
    super();
  }

  async createChart(data: Chart): Promise<ApiDocument<Chart>> {
    return await this.strapiService.create<Chart>(ContentType.CHARTS, data);
  }

  async getChartById(id: number): Promise<ApiDocument<Chart>> {
    const result = await this.strapiService.getById<ChartFull>(
      ContentType.CHARTS,
      id,
      {
        populate: {
          indicators: true,
        },
      }
    );

    return {
      ...result,
      data: {
        ...result.data,
        indicators: result.data.indicators?.map((d) => d.id),
      },
    };
  }

  async getChartsByCartoPage(
    pageCartoId: number
  ): Promise<ApiCollection<Chart>> {
    const result = await this.strapiService.get<ChartFull>(ContentType.CHARTS, {
      populate: {
        indicators: true,
      },
      filters: {
        page_carto: { id: { $eq: pageCartoId } },
      } as QueryParams['filters'],
    });

    return {
      ...result,
      data: result.data.map((v) => ({
        ...v,
        indicators: v?.indicators?.map((d) => d.id),
      })),
    };
  }

  async updateChart(
    id: number,
    data: Partial<Chart>
  ): Promise<ApiDocument<Chart>> {
    return await this.strapiService.update(ContentType.CHARTS, id, { data });
  }

  async deleteChart(id: number) {
    return await this.strapiService.delete<Chart>(ContentType.CHARTS, id);
  }
}
